import { render, staticRenderFns } from "./paymentInfo.vue?vue&type=template&id=5f3bce38&scoped=true&"
import script from "./paymentInfo.vue?vue&type=script&lang=js&"
export * from "./paymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./paymentInfo.vue?vue&type=style&index=0&id=5f3bce38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3bce38",
  null
  
)

export default component.exports